import { ReactComponent as FlagIcon } from "./svg/uy-flag.svg";
import "../flag-icon.scss";

export const UYFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
